module.exports = __webpack_public_path__ + "media/images/plans/proposal-schedule_1-5ae4ecef464210c9876a28957cc36735.jpg";